var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22644 3.39126C6.88612 3.74459 5.01446 5.67747 4.73304 8.16171L4.44564 10.6988C4.37423 11.3292 4.11873 11.9224 3.71292 12.4001C2.85175 13.4137 3.55069 15 4.85846 15H15.1416C16.4493 15 17.1483 13.4137 16.2871 12.4001C15.8813 11.9224 15.6258 11.3292 15.5544 10.6988L15.3645 9.0223M12.5 16.6667C12.1361 17.6377 11.1542 18.3334 10 18.3334C8.84582 18.3334 7.86391 17.6377 7.50001 16.6667M16.6667 4.16669C16.6667 5.5474 15.5474 6.66669 14.1667 6.66669C12.786 6.66669 11.6667 5.5474 11.6667 4.16669C11.6667 2.78598 12.786 1.66669 14.1667 1.66669C15.5474 1.66669 16.6667 2.78598 16.6667 4.16669Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavNotifications);
export default __webpack_public_path__ + "static/media/sidenav-notifications.66ae53df357c1c5056cfca6720491bba.svg";
export { ForwardRef as ReactComponent };